import { CustomEventWithDetail, html, type Html, View } from 'rune-ts';
import klass from './CreatorApplicationHeader.module.scss';
import NewHeadroom from 'headroom.js';
import { MarppleShopTextLogo } from '@services/MarppleShop/renderApp/components/atoms/Icon';
import { makeHomeScreenNavigate } from '@services/MarppleShop/shared/app/navigate';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';

export class toggleHeaderMenu extends CustomEventWithDetail<{ status: boolean }> {}
export class navigateChapter extends CustomEventWithDetail<{
  target_section: string;
}> {}

export class CreatorApplicationHeader extends View<{ is_mobile: boolean }> {
  headroom?: NewHeadroom;
  current_theme = 'white';

  override template(): Html {
    return html`
      <div class="${klass.header}">
        <div class="${klass.menu_wrapper}">
          <a href="/${ET.lang}" data-post-message="${dataStr(makeHomeScreenNavigate())}"
            >${MarppleShopTextLogo}</a
          >
        </div>
      </div>
    `;
  }

  protected override onRender() {
    this.headroom = new NewHeadroom(this.element(), {});
    this.headroom.init();
  }

  setThemeColor(theme: string) {
    if (theme === this.current_theme) return;
    this.current_theme = theme;
    if (theme === 'blue') {
      this.element().classList.add(klass.blue);
    } else {
      this.element().classList.remove(klass.blue);
    }
  }
}
